import { db } from '../../firebase/config'
import firebase from '../../firebase/compat'
import ActivityMeta from '../activities/ActivityMeta'
import MultiSelect from '../common/MultiSelect'

// Multi-select chip picker for linking activities to a parent record
// (collection controlled by `type`, e.g. StorytellingInterviews).
const PairActivities = ({ type, item, activities, setSaved }) => {
    const selected = Array.isArray(item.Activity) ? item.Activity : []

    const toggle = (id, isSelected) => {
        const op = isSelected
            ? firebase.firestore.FieldValue.arrayRemove(id)
            : firebase.firestore.FieldValue.arrayUnion(id)
        db.collection(type)
            .doc(item.docid)
            .update({ Activity: op })
            .then(() => setSaved('flex'))
    }

    const options = (activities || []).map(a => ({ id: a.ID, label: a.Activity }))

    return (
        <MultiSelect
            selected={selected}
            options={options}
            onToggle={toggle}
            renderSelected={(id) => <ActivityMeta id={id} inline={true} />}
            addLabel='+ Activiteit toevoegen'
            emptyLabel='Geen activiteit(en) toegevoegd'
            emptyOptionsLabel='Geen activiteiten beschikbaar'
            removeAriaLabel='Verwijder activiteit'
        />
    )
}

export default PairActivities
